import * as gateway from 'sfx-web-contract';
import { IDisclaimerApprovalSaveResponse, IDisclaimerResponse, IStreamData } from '../../../interfaces';

export const decodeDisclaimerResponse = (response: IStreamData<Uint8Array>): IDisclaimerResponse => {
    const {
        IsApproved: isApproved,
        Clauses: clauses,
    } = gateway.DisclaimerResponse.decode(response.payload);

    return { isApproved, clauses };
};

export const decodeDisclaimerApprovalSaveResponse = (response: IStreamData<Uint8Array>): IDisclaimerApprovalSaveResponse => {
    const {
        Accepted: isAccepted,
        Reason: reason,
    } = gateway.DisclaimerApprovalSaveResponse.decode(response.payload);

    return { isAccepted, reason };
};
